import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=747d8e1a&"
import script from "./NotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./NotificationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports